import { Type } from 'class-transformer';

import { UserBasic } from '@eiq/users/data';

import { CrosstabSaved } from '@empathy/global/crosstabs/models';
import { DiscussionForum, ProjectAnswerStatus, ResearchType } from '@empathy/global/data';

import { ProjectAiInterviewContent } from './ai-interview/project-ai-interview-content.model';
import { ResearchAudienceTypeEnum } from './audience/audience-type.enum';
import { Query } from './audience/deploy-to-panel/query/query.model';
import { ResearchAudience } from './audience/research-audience.model';
import { ClientBriefSettings } from './client-brief-settings.model';
import { ProjectEndPages } from './project-end-pages.interface';
import { ProjectSurveyContent } from './project-survey-content.model';
import { Quota } from './quotas/quota.model';
import { ResearchDetails } from './research-details.model';
import { IParticipantSettings } from './settings/participant-settings.interface';

export class ResearchMethod {
  id: string;
  referenceCode: string;
  researchType: ResearchType;
  status: number;
  // Todo: this wil be deleted as part of code clean up - EQ-1123
  audience: { qualifications: Query; audienceType: ResearchAudienceTypeEnum; endPages: ProjectEndPages };
  audiences: ResearchAudience[];
  quotas: Quota[];
  // eslint-disable-next-line @typescript-eslint/member-ordering
  @Type(() => ResearchDetails)
  researchDetails: ResearchDetails;
  countryCode: string;
  language: string;
  lockedByName?: string;
  lockedDateTime?: Date;
  projectSurveyContent?: ProjectSurveyContent;
  projectAiInterviewContent?: ProjectAiInterviewContent;
  discussionForumContent?: DiscussionForum;
  nonCompleteCompensation: Record<ProjectAnswerStatus, number>;
  crossTabs: CrosstabSaved[];
  invitedUsers: UserBasic[];
  launchedByName: string;
  launchedStartDate?: Date;
  relaunchedByName?: string;
  relaunchedDateTime?: Date;
  numResponses: number;
  clientBriefSettings?: ClientBriefSettings;
  participantSettings?: IParticipantSettings;
}
